import React, { Fragment, useEffect, useState, useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import { olguColumn } from "Constants/TableColumns";
import { Grid } from "@material-ui/core";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { toggleNLolayiKeshoyi } from "Constants/Constants";
import MuiToggleButtonGroup from "Components/MuiToggleButtonGroup/MuiToggleButtonGroup";
import { read } from "Helpers/LocalStorage";
import { getGroupProfileWithType, getOlguList, disableOlgu, changeOlguSearch } from "Stores/actions";
import { GET_OLGU_AGAIN, SAVE_ALL_OLGU_DATA } from "Stores/actionTypes";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import cellEditFactory from "react-bootstrap-table2-editor";
import Search from "Assets/svg/icon/search.svg";
import Input from "Components/Input/Input";
import { ReactSVG } from "react-svg";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { useTranslation } from 'react-i18next';
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import { useSetState } from "Helpers/Hooks";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";

function TblOlgu({toggle, setToggle, changes, clearChanges, profile}) {
  const { t } = useTranslation();
  const { allOlguData, dasteProfileListWithType, allOlguDataPagination, allOlguDataSearch, getAllOlguAgain } = useSelector((state) => ({
    allOlguData: state.pattern.allOlguData,
    dasteProfileListWithType: state.pattern.dasteProfileListWithType,
    allOlguDataPagination: state.pattern.allOlguDataPagination,
    allOlguDataSearch: state.pattern.allOlguDataSearch,
    getAllOlguAgain: state.pattern.getAllOlguAgain,
  }));
  const [selectOptionsDasteProfile, setSelectOptionsDasteProfile] = useState([]);
  const [selectDasteProfileId, setSelectDasteProfileId] = useState(null);
  const [sizePerPage, setSizePerPage] = useState(allOlguDataPagination.Limit);
  const [currentPage, setCurrentPage] = useState(allOlguDataPagination.Page);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState(allOlguData);
  // const [type, setType] = useState("lolayi");
  const dispatch = useDispatch();
  const [floading, setFLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const firstUpdate = useRef(true);
  const [controls, setControls] = useSetState({
    selectType: {
      type: "toggle",
      arrayItems: toggleNLolayiKeshoyi,
      value: toggleNLolayiKeshoyi[0],
    },
    dasteProfile: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: 6,
    },
  });

  useEffect(() => {
    onChangeToggle('selectType', null, toggleNLolayiKeshoyi[0]);
  },[])

  useEffect(() => {
    if(changes) {
      if(changes.toggle && !changes.profile)
        onChangeToggle('selectType', null, toggle === 1 ? toggleNLolayiKeshoyi[0] : toggleNLolayiKeshoyi[1]);
      else if(!changes.toggle && changes.profile)
        handleChangeDasteProfile(null, profile);
      else if(changes.toggle && changes.profile)
        onChangeToggle('selectType', null, toggle === 1 ? toggleNLolayiKeshoyi[0] : toggleNLolayiKeshoyi[1], {getProfile: true});
      clearChanges();
    }
  },[changes])

  useEffect(() => {
    if (allOlguData) {
      setTblData(allOlguData);
      setTotal(allOlguDataPagination.Total);
    }
  }, [allOlguData, allOlguDataPagination]);

  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
  }, [allOlguDataSearch]);

  const handleChangeDasteProfile = async (e, selectedObj) => {
    setLoading(true);
    try {
      setControls({ dasteProfile: { value: selectedObj } });
      const paramsOlgu = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdGroupProfile: selectedObj.value,
        Name: allOlguDataSearch?.Name,
        Page:1,
        Limit:sizePerPage
      };
      await dispatch(getOlguList(paramsOlgu));
      setSelectDasteProfileId(selectedObj.value);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };


  const onChangeToggle = async (name, key, value, option = null) => {
    setControls({ [name]: { value: value } });
    const idType = value.value === "lolayi" ? 1 : 2;
    setLoading(true);
    try {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdType: idType,
      };
      const dasteProfile = await dispatch(getGroupProfileWithType(params));
      setToggle(idType);
      setSelectOptionsDasteProfile(dasteProfile);
      setControls({ dasteProfile: { selectItems: dasteProfile } });
      if(option) {
        handleChangeDasteProfile(null, profile);
      } else {
        if (dasteProfile.length >= 1) {
          handleChangeDasteProfile(null, dasteProfile[0]);
        } else {
          dispatch({
            type: SAVE_ALL_OLGU_DATA,
            allOlguData: [],
            allOlguDataPagination: { Limit: 10, Page: 1, Total: 0 },
          });
        }
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
    setTimeout(() => {
      setFLoading(false);
      setLoading(false);
    }, 500);
  };

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      setLoading(true);
      try {
        const paramsOlgu = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdGroupProfile: selectDasteProfileId,
          Limit: sizePerPage,
          Page: page,
          Name: allOlguDataSearch?.Name,
        };
        await dispatch(getOlguList(paramsOlgu));
        setCurrentPage(page);
        setSizePerPage(sizePerPage);
      } catch (err) {
      console.error('[catch error]', err)
    }
      setTimeout(() => {
      setLoading(false);
    }, 500);
    }
  };

  useEffect(()=> {
    (async() => {
      if(getAllOlguAgain) {
        setLoading(true);
        try {
          dispatch({ type: GET_OLGU_AGAIN, data: false });
          const paramsOlgu = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdGroupProfile: selectDasteProfileId,
            Limit: sizePerPage,
            Page: currentPage,
            Name: allOlguDataSearch?.Name,
          };
          await dispatch(getOlguList(paramsOlgu));
        } catch (err) {
      console.error('[catch error]', err)
    }
        setTimeout(() => {
      setLoading(false);
    }, 500);
      }
    })()
  }, [getAllOlguAgain])

  const setValue = (name, value) => {
    dispatch(changeOlguSearch({ Name: value }));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        IdGroupProfile: selectDasteProfileId,
        Page: 1,
        Name: convertToEnglishNumber(allOlguDataSearch.Name),
      };
      await dispatch(getOlguList(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    dispatch(changeOlguSearch({ Name: "" }));
    setLoading(true);
    try {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Limit: sizePerPage,
        IdGroupProfile: selectDasteProfileId,
        Page: 1,
      };
      await dispatch(getOlguList(params));
      setCurrentPage(1);
    } catch (err) {
      console.error('[catch error]', err)
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }

  const BeforeSaveCell = async (oldValue, newValue, row, column) => {
    if (column.dataField === "Disable") {
      if (JSON.parse(newValue) !== JSON.parse(oldValue)) {
        setLoading(true);
        const updateNewValue = JSON.parse(newValue);
        if (oldValue !== updateNewValue) {
          try {
            const data = {
              KeyGroup: read("groupKey"),
              KeyUser: read("userKey"),
              IdTemplate: +row.Id,
              Type: row.Type,
              Disable: updateNewValue,

            };
            await dispatch(disableOlgu(data));
            const params = {
              KeyGroup: read("groupKey"),
              KeyUser: read("userKey"),
              IdType: row.Type,
            };
            await dispatch(getGroupProfileWithType(params));
            await dispatch(getOlguList({
              KeyGroup: read("groupKey"),
              KeyUser: read("userKey"),
              Limit: sizePerPage,
              IdGroupProfile: selectDasteProfileId,
              Page: 1,
            }));
            setCurrentPage(1);
          } catch (err) {
      console.error('[catch error]', err)
    }
        }
        setLoading(false);
      }
    }
  };

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <Grid container spacing={2} className="p-3">
        {
          floading ? <Grid item xs={12} className="py-4 my-2">
            <MuiSkeleton xs={4} number={3} />
          </Grid>
          : <>
            <Grid item lg={3} md={4} sm={12} xs={12}>
              <MuiRadioGroup
                name={"selectType"}
                label={<Translator id={'selectType'} />}
                value={controls.selectType.value}
                items={controls.selectType.arrayItems}
                onChange={onChangeToggle}
                translate={true}
                className="horizontalRadio"
              />
            </Grid>
            <Grid item lg={3} md={4} sm={12} xs={12} className="d-flex flex-row align-items-end">
              <Input
                setValue={setValue.bind(this)}
                name="search"
                value={allOlguDataSearch ? allOlguDataSearch.Name : ""}
                // label={<Translator id="nameSearch" />}
                placeholder={t('nameSearch')}
                type="search"
                onSearch={onSearch}
                onClearSearch={onClearSearch}
              />
            </Grid>
            <Grid item lg={3} md={4} sm={12} xs={12}>
              {
                selectOptionsDasteProfile && selectOptionsDasteProfile.length > 0 &&
                <MuiAutoComplete
                  options={controls.dasteProfile.selectItems}
                  label={<Translator id={"searchProfileCategories"} />}
                  value={controls.dasteProfile.value}
                  id={'dasteProfile'}
                  onChange={handleChangeDasteProfile}
                />
              }
            </Grid>
          </>
        }
      </Grid>
      <RemoteTable
        keyField="num"
        data={tblData}
        columns={olguColumn}
        loading={loading}
        page={currentPage}
        sizePerPage={sizePerPage}
        totalSize={total}
        onTableChange={onTableChange}
        title={<Translator id="list_olgo" />}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
          beforeSaveCell: (oldValue, newValue, row, column, done) =>
            BeforeSaveCell(oldValue, newValue, row, column, done),
        })}
      />
    </Fragment>
  );
}

export default TblOlgu;
